import React from 'react';
import loadable from '@loadable/component';

export const Unsubscribe = loadable(
  () => import(/* webpackChunkName: "profile" */ './unsubscribe-landing-page')
);

// Fixes loadable type errors `Property 'graphQL' does not exist on type`

const UnsubscribeLandingPage = () => {
  return <Unsubscribe />;
};

type QueryVariables = {
  // eslint-disable-next-line camelcase
  group_id: string;
  // eslint-disable-next-line camelcase
  user_id: string;
  hash: string;
};

UnsubscribeLandingPage.variables = (props: QueryVariables) => ({
  id: props.group_id,
  subscribed: false,
  userID: props.user_id,
  hash: props.hash,
});

export default UnsubscribeLandingPage;
